import { supabase, forceClearAllSupabaseStorage } from "./supabaseClient";

/**
 * 로그아웃 후 공개 소개 랜딩('/')으로 보낸다.
 *
 * SPA 이동(navigate)이 아니라 전체 새로고침을 쓰는 이유:
 * 세션만 끊고 navigate('/') 를 하면 아직 살아 있는 화면과 UserContext 가
 * 서로 다른 곳으로 보내려 해서 결국 /login 으로 튕긴다.
 *   - ProtectedRoute 는 userInfo.email 이 비는 순간 즉시 /login 으로 보낸다
 *   - UserContext 는 세션 변경 반영이 스로틀·디바운스돼 바로 비워지지 않는다
 *     (그 사이에 '/' 에 닿으면 Landing 이 로그인 상태로 보고 /home 으로 되돌린다)
 * 어느 쪽을 먼저 하든 경쟁이 생긴다. 전체 새로고침이면 이 경쟁 자체가 없고,
 * 메모리에 남은 사용자 캐시까지 확실히 비운다 — 로그아웃에 오히려 알맞다.
 *
 * 네이티브 앱에서는 Landing 이 '/' 를 다시 /login 으로 보내므로
 * 앱의 기존 진입 플로우는 그대로 유지된다.
 *
 * assign 이 아니라 replace 를 쓰는 이유: 방금 로그아웃한 주소를 기록에 남기지
 * 않아, 뒤로가기로 로그인 상태였던 화면에 돌아가려는 시도 자체를 없앤다.
 *
 * 2026-09-11 (사파리에서 로그아웃이 안 되던 문제, 대표 보고):
 * `supabase.auth.signOut()` 은 서버 로그아웃(POST /auth/v1/logout)이 401·403·404 가 아닌 이유로 실패하면
 * — 네트워크 오류, 5xx, 브라우저가 요청을 막은 경우 — **오류를 throw 하지 않고 `{ error }` 를 돌려주면서
 * 로컬 세션을 지우지 않는다.** 종전 코드는 throw 만 잡았으므로 그 경우 세션이 그대로 남은 채 '/' 로 갔고,
 * 랜딩이 로그인 상태로 보고 /home 으로 되돌렸다(= 「로그아웃해도 안 된다」).
 * 그래서 서버 로그아웃 결과와 무관하게 ① 로컬 세션 제거(scope 'local' 은 서버를 부르지 않는다)
 * ② 저장소의 sb-* 키·impersonateEmail 강제 삭제(🔴 forceClearAllSupabaseStorage) 를 항상 수행한다.
 * 서버 쪽 토큰 폐기가 실패해도 이 기기에서는 확실히 로그아웃되고, 남은 refresh 토큰은 만료로 소멸한다.
 */
export const logoutToLanding = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error("서버 로그아웃 실패 — 로컬 세션만 지웁니다:", error);
      await supabase.auth.signOut({ scope: "local" });
    }
  } catch (error) {
    // 세션 해제가 실패해도(네트워크·잠금 등) 화면은 로그아웃 상태로 넘긴다.
    console.error("로그아웃 처리 중 오류:", error);
    try { await supabase.auth.signOut({ scope: "local" }); } catch (e) { /* 아래 강제 삭제가 마무리한다 */ }
  }
  forceClearAllSupabaseStorage();
  window.location.replace("/");
};
